<template>
  <div>
    <button @click="openModal" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded focus:outline-none focus:shadow-outline w-full mb-3">
      {{ uiT('groups.create') }}
    </button>
    <div v-if="isModalOpen" class="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg relative" @click.stop>
        <button @click="closeModal" class="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-lg leading-none">
          &times;
        </button>
        <form @submit.prevent="createGroup">
          <div class="mb-4">
            <label for="groupName" class="block text-gray-700 font-medium">{{ uiT('groups.name') }}</label>
            <input id="groupName" v-model="groupName" type="text" required class="mt-1 w-full border border-gray-300 rounded-md shadow-sm px-4 py-2">
          </div>

          <template v-if="sinLimitesCargaUsuarios">
            <div class="mode-card mb-5">
              <div>
                <div class="mode-title">{{ uiT('groups.freeModeTitle') }}</div>
                <div class="mode-sub">{{ uiT('groups.freeModeHelp') }}</div>
              </div>
            </div>

            <div class="space-y-3 mb-5">
              <label class="toggle-row">
                <span>{{ uiCategoryLabel(labelStaff, 'staff') }}</span>
                <span class="switch-control">
                  <input v-model="mostrarStaff" type="checkbox" class="switch-checkbox" />
                  <span class="switch-ui"><span class="switch-knob"></span></span>
                </span>
              </label>
              <label class="toggle-row">
                <span>{{ uiCategoryLabel(labelExpositor, 'conferencistas') }}</span>
                <span class="switch-control">
                  <input v-model="mostrarConferencistas" type="checkbox" class="switch-checkbox" />
                  <span class="switch-ui"><span class="switch-knob"></span></span>
                </span>
              </label>
              <label class="toggle-row">
                <span>{{ uiCategoryLabel(labelAsistentes, 'asistentes') }}</span>
                <span class="switch-control">
                  <input v-model="mostrarAsistentes" type="checkbox" class="switch-checkbox" />
                  <span class="switch-ui"><span class="switch-knob"></span></span>
                </span>
              </label>
            </div>
          </template>

          <div v-else class="grid grid-cols-3 gap-4 mb-5">
            <div>
              <label for="cantStaff" class="block text-gray-700 font-medium"># {{ uiCategoryLabel(labelStaff, 'staff') }}</label>
              <input id="cantStaff" v-model="cantStaff" type="number" min="0" max="99" class="mt-1 w-full border border-gray-300 rounded-md shadow-sm px-4 py-2">
            </div>
            <div>
              <label for="cantConferencista" class="block text-gray-700 font-medium"># {{ uiCategoryLabel(labelExpositor, 'conferencistas') }}</label>
              <input id="cantConferencista" v-model="cantConferencista" type="number" min="0" max="99" class="mt-1 w-full border border-gray-300 rounded-md shadow-sm px-4 py-2">
            </div>
            <div>
              <label for="cantAsistente" class="block text-gray-700 font-medium"># {{ uiCategoryLabel(labelAsistentes, 'asistentes') }}</label>
              <input id="cantAsistente" v-model="cantAsistente" type="number" min="0" class="mt-1 w-full border border-gray-300 rounded-md shadow-sm px-4 py-2">
            </div>
          </div>

          <button type="submit" class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full">{{ uiT('common.create') }}</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { useToast } from "vue-toastification";
import { userManagementI18nMixin } from "@/views/usuarios/i18n/userManagementI18n.js";

export default {
  mixins: [userManagementI18nMixin],
  setup() {
    const toast = useToast();
    return { toast };
  },
  props: {
    eventoToken: { type: String, required: true },
    sinLimitesCargaUsuarios: { type: Boolean, default: false },
    labelStaff: { type: String, default: 'Staff' },
    labelAsistentes: { type: String, default: 'Asistentes' },
    labelExpositor: { type: String, default: 'Expositores' }
  },
  data() {
    return {
      isModalOpen: false,
      groupName: '',
      groupDescription: '',
      cantStaff: 0,
      cantAsistente: 0,
      cantConferencista: 0,
      mostrarStaff: true,
      mostrarAsistentes: true,
      mostrarConferencistas: true,
    };
  },
  computed: {
    ...mapState({
      authToken: state => state.user.token
    })
  },
  methods: {
    openModal() {
      this.isModalOpen = true;
      if (this.sinLimitesCargaUsuarios) {
        this.mostrarStaff = true;
        this.mostrarAsistentes = true;
        this.mostrarConferencistas = true;
      }
    },
    closeModal() {
      this.isModalOpen = false;
    },
    createGroup() {
      axios.post('/api/groups/create', {
        name: this.groupName,
        description: this.groupDescription,
        cantStaff: this.sinLimitesCargaUsuarios ? 0 : this.cantStaff,
        cantAsistente: this.sinLimitesCargaUsuarios ? 0 : this.cantAsistente,
        cantConferencista: this.sinLimitesCargaUsuarios ? 0 : this.cantConferencista,
        mostrarStaff: this.sinLimitesCargaUsuarios ? (this.mostrarStaff ? '1' : '0') : (Number(this.cantStaff) > 0 ? '1' : '0'),
        mostrarAsistentes: this.sinLimitesCargaUsuarios ? (this.mostrarAsistentes ? '1' : '0') : (Number(this.cantAsistente) > 0 ? '1' : '0'),
        mostrarConferencistas: this.sinLimitesCargaUsuarios ? (this.mostrarConferencistas ? '1' : '0') : (Number(this.cantConferencista) > 0 ? '1' : '0'),
        tokenEvento: this.eventoToken,
        tokenUser: this.authToken
      }).then(response => {
        this.$emit('groupCreated', response.data);
        this.toast.success(this.uiT('groups.created'));
        this.closeModal();
      }).catch(error => {
        console.error('Error creating group:', error);
      });
    }
  }
}
</script>
<style scoped>
.bg-opacity-40{ z-index: 31; }
.mode-card {
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  background: #f8fafc;
  padding: 14px;
}
.mode-title { font-weight: 700; color: #0f172a; }
.mode-sub { margin-top: 6px; font-size: 0.9rem; color: #64748b; }
.toggle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
}

.switch-control {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.switch-checkbox {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.switch-ui {
  width: 52px;
  height: 30px;
  border-radius: 999px;
  background: #cbd5e1;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.08);
}
.switch-knob {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.25);
  transition: transform 0.2s ease;
}
.switch-checkbox:checked + .switch-ui {
  background: #22c55e;
}
.switch-checkbox:checked + .switch-ui .switch-knob {
  transform: translateX(22px);
}
.switch-checkbox:focus-visible + .switch-ui {
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.22);
}
</style>
